/* tslint:disable */
/* eslint-disable */
/**
 * POK
 * Opis api POK
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateUpdateEodVatRegisterDto
 */
export interface CreateUpdateEodVatRegisterDto {
    /**
     * 
     * @type {number}
     * @memberof CreateUpdateEodVatRegisterDto
     */
    documentId: number;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateEodVatRegisterDto
     */
    registerName: string;
    /**
     * 
     * @type {string}
     * @memberof CreateUpdateEodVatRegisterDto
     */
    vatRate: string;
    /**
     * 
     * @type {number}
     * @memberof CreateUpdateEodVatRegisterDto
     */
    netAmount: number;
    /**
     * 
     * @type {number}
     * @memberof CreateUpdateEodVatRegisterDto
     */
    vatAmount: number;
    /**
     * 
     * @type {number}
     * @memberof CreateUpdateEodVatRegisterDto
     */
    grossAmount: number;
}

/**
 * Check if a given object implements the CreateUpdateEodVatRegisterDto interface.
 */
export function instanceOfCreateUpdateEodVatRegisterDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "documentId" in value;
    isInstance = isInstance && "registerName" in value;
    isInstance = isInstance && "vatRate" in value;
    isInstance = isInstance && "netAmount" in value;
    isInstance = isInstance && "vatAmount" in value;
    isInstance = isInstance && "grossAmount" in value;

    return isInstance;
}

export function CreateUpdateEodVatRegisterDtoFromJSON(json: any): CreateUpdateEodVatRegisterDto {
    return CreateUpdateEodVatRegisterDtoFromJSONTyped(json, false);
}

export function CreateUpdateEodVatRegisterDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateUpdateEodVatRegisterDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'documentId': json['documentId'],
        'registerName': json['registerName'],
        'vatRate': json['vatRate'],
        'netAmount': json['netAmount'],
        'vatAmount': json['vatAmount'],
        'grossAmount': json['grossAmount'],
    };
}

export function CreateUpdateEodVatRegisterDtoToJSON(value?: CreateUpdateEodVatRegisterDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'documentId': value.documentId,
        'registerName': value.registerName,
        'vatRate': value.vatRate,
        'netAmount': value.netAmount,
        'vatAmount': value.vatAmount,
        'grossAmount': value.grossAmount,
    };
}

